export default __webpack_public_path__ + "static/media/ravit_edelman.e077726c.jpeg";